<script>
	export let data;
	import { isNewDataChanged } from "../../../../stores/variables";

	let loaded = 0;

	if (data) {
		if (!data.newData) data.newData = [];

		if (data.newData) {
			data.field_names.forEach((field_name) => {
				data.services.forEach((service) => {
					if (service.field_name == field_name) {
						if (data.newData[field_name]) service.active = true;
					}
				});
			});
			loaded++;
		}
	}

	$: if (data) {
		loaded++;
		if (loaded > 2) {
			$isNewDataChanged = true;
			data.field_names.forEach((field_name) => {
				data.services.forEach((service) => {
					if (service.field_name == field_name) {
						if (service.active) {
							data.newData[field_name] = "on";
						} else {
							data.newData[field_name] = "";
						}
					}
				});
			});
		}
	}
</script>

{#if data}
	<div class="services">
		{#if data.name}
			<h3>{data.name}</h3>
		{/if}
		<div class="services__content">
			{#each data.services as service}
				<label>
					<input type="checkbox" bind:checked={service.active} />
					<span>
						<span>{service.service}</span>
						<i class="far fa-times svelte-5ntbuy" />
					</span>
				</label>
			{/each}
		</div>
	</div>
{/if}

<style lang="scss">
	.services {
		display: flex;
		flex-direction: column;
		max-width: var(--module-width-1);

		&__content {
			display: flex;
			flex-wrap: wrap;
			margin: 0 -15px;

			> label {
				cursor: pointer;
				display: flex;
				align-items: center;
				padding: 6px 15px;
				flex-basis: 50%;
				user-select: none;

				@media (max-width: 767px) {
					flex-basis: 100%;
				}

				> span {
					display: flex;
					align-items: center;
					position: relative;
					transition: all 0.1s ease;

					&::before {
						content: "";
						display: flex;
						flex-shrink: 0;
						height: 20px;
						width: 40px;
						background: var(--bg-gray-1);
						border-radius: 100px;
						transition: all 0.1s ease;
						margin-right: 6px;
					}

					&::after {
						position: absolute;
						display: flex;
						flex-shrink: 0;
						content: "";
						left: 1px;
						height: 18px;
						width: 18px;
						border-radius: 50%;
						background-color: var(--bg-main-1);
						transition: all 0.1s ease;
					}
					> i {
						display: none;
					}
				}

				> input {
					display: none;
					&:checked + span {
						color: var(--color-1);
						&::after {
							left: 21px;
						}
						&::before {
							background-color: var(--color-1);
						}
					}
				}
			}
		}
	}
</style>
